//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { SaveRegisterQuestionnaire } from '@/service/request';

export default {
  data() {
    return {
      storeName: '',
    };
  },

  computed: {
    user() {
      return this.$store.state.user;
    },
    secrecy() {
      return this.$store.state.secrecy;
    },
  },

  methods: {
    removeLocalInfo() {
      this.$store.commit('SET_SECRECY', null);
      this.$store.commit('SET_USER', null);
    },
    handleSure() {
      let { account, password } = this.secrecy;
      let params = {
        account,
        password,
        questionnaireJson: JSON.stringify(this.user),
      };

      SaveRegisterQuestionnaire(params)
        .then(() => {
          this.jump();
          this.removeLocalInfo();
        })
        .catch(() => {
          // this.removeLocalInfo();
          // this.jump();
        });
    },
    jump() {
      this.$router.push('/success');
    },
    handleSureClick() {
      this.$store.commit('SET_USER_FIELD', {
        key: 'storeName',
        value: this.storeName,
      });

      this.handleSure();
    },
  },

  created() {},

  mounted() {},
};



// WEBPACK FOOTER //
// ./src/views/step/step03.vue